import { useEffect, useState } from "react";

function Home() {
  
  return (
    
   <section className="hero">
  <div className="hero-card">

    {/* 🔥 Header */}
    <div className="hero-badge">
      🚀 SkillClashX For Sale
    </div>

    <h1 className="hero-title">
      Ready-Made Esports Tournament Platform
    </h1>
{/* 📩 Contact */}
<div className="hero-actions">

  <a
    className="download-btn"
    href="https://github.com/mineshrathwa46-stack/skillclash-app/releases/download/v1.0/SkillClash-v1.apk"
    target="_blank"
    rel="noreferrer"
  >
    👀 See App
  </a>

</div>

    {/* 🔒 Trust */}
    <p className="hero-trust">
      ✔ Production Ready • ✔ Firebase Backend • ✔ Flutter Apps
    </p>

    {/* 📊 Stats */}
    <div className="stats-grid">
      <div className="stat-pill">
        📱 Flutter User App
      </div>

      <div className="stat-pill">
        🛠️ Admin App Included
      </div>

      <div className="stat-pill">
        🔥 Real-Time Firebase
      </div>
    </div>

    {/* 🎮 PROJECT INFO */}
    <div className="tournament-section">

      <h2>🚀 Included In Sale</h2>

      <div className="tournament-list">

        <div className="tournament-card">

          {/* HEADER */}
          <div className="t-header">
            <span>SkillClashX Platform</span>

            <span className="entry">
              READY PROJECT
            </span>
          </div>

          {/* BODY */}
          <div className="t-body">

            <p>
              ✅ Flutter Android User App
            </p>

            <p>
              ✅ Separate Flutter Admin App
            </p>

            <p>
              ✅ Firebase Backend Integration
            </p>

            <p>
              ✅ Live Tournament System
            </p>

            <p>
              ✅ Countdown Timers
            </p>

            <p>
              ✅ Tournament Slot Management
            </p>

            <p>
              ✅ APK Build Setup
            </p>

            <p>
              ✅ Responsive Website
            </p>

            <p>
              ✅ SEO Indexed Domain
            </p>

            <p>
              🌐 Domain Included:
              skillclashx.com
            </p>

          </div>

          {/* FOOTER */}
          <div className="t-footer">

            <a
              href="mailto:mineshrathwa46@gmail.com"
              className="join-btn"
            >
              Contact For Details 📩
            </a>

          </div>

        </div>

      </div>
    </div>

  </div>
</section>
  );
}

export default Home;